import React from 'react';
import ServicePageLayout from '../../components/ServicePageLayout';
import { trademarkRegisterData } from '../../data/serviceData';

const TrademarkRegister = () => {
  return <ServicePageLayout data={trademarkRegisterData} />;
};

export default TrademarkRegister;
